/// <reference path="../../../../node_modules/@ms/office-online-strings/en-US/transcription-strings.d.ts" />
import * as React from 'react';
import { Dialog, DialogFooter, Label } from 'office-ui-fabric-react';
import { AppButton } from '../AppButton';
import { getTopLabelStyles, getModalProps, getDialogContentProps } from './Popup.styles';
import { AppLayoutSettings } from '../../pages/common.styles';
import { AppAuthenticationProviderContext } from '../../context';
import { IAuthenticationProvider } from '../../../backend/interfaces/IAuthenticationProvider';
import { AuthPopupProps } from './AuthPopup.props';
import { GraphBaseUrlFromAuthEnvironment } from '../../../backend/ms-graph/GraphClientInitOptions';
import { ILogEvent } from '../../../backend/interfaces/ILogEvent';
import { AuthPopupKeys } from '../../pages/telemetry/AuthPopupKeys';
import { LogEventNames } from '../../../backend/interfaces/ITelemetryLogger';
import { LogEvent } from '../../../backend/TelemetryLogger/LogEvent';
import { ErrorStringFromException } from '../../../utils/utils';

declare const OfficeFirstPartyAuth: any;

export class AuthPopup extends React.PureComponent<AuthPopupProps, {}> {
    static contextType = AppAuthenticationProviderContext;

    constructor(props: AuthPopupProps) {
        super(props);
    }

    private async onExecute() {
        const AuthPopupTelemetry: ILogEvent<AuthPopupKeys> = new LogEvent<AuthPopupKeys>(LogEventNames.AuthPopup);
        AuthPopupTelemetry.Start();
        try {
            const authProvider: IAuthenticationProvider = this.context;
            const token: string = await OfficeFirstPartyAuth.getAccessToken({ "resource": GraphBaseUrlFromAuthEnvironment(authProvider.GetAuthEnvironment()) }, { "popup": true });
            AuthPopupTelemetry.End([{ key: AuthPopupKeys.AuthPopupSuccess, value: true}]);
            this.props.onAuthSucceeded(token);
        } catch (e) {
            AuthPopupTelemetry.End([{ key: AuthPopupKeys.AuthPopupSuccess, value: false}, { key: AuthPopupKeys.AuthPopupFailureReason, value: ErrorStringFromException(e)}]);
            this.props.onAuthFailed(e);
        }
    }

    public render() {
        // VSO: 4379118: Need 3 localized strings below
        const title: string | JSX.Element = 
                <Label styles={getTopLabelStyles()}>
                    Verify your identity
                </Label>

        return (
            <Dialog
                dialogContentProps={getDialogContentProps(title, true /*showCloseButton*/)}
                modalProps={getModalProps()}
                hidden={false}
                onDismiss={() => this.props.onDialogClosed()}
            >
                <Label styles={AppLayoutSettings.AppCommonStyles.getPageTopLabelStyles()}>Your browser settings require you to verify your identity before you can access Office.</Label>
                <DialogFooter>
                    <AppButton 
                        type={'AppButtonProps'} 
                        id="VerifyButton" 
                        text="Verify"
                        onExecute={() => this.onExecute() } 
                    />
                </DialogFooter>
            </Dialog>
         );
    }
}